module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.sidebarClasses,
    attrs: {
      "data-background-color": _vm.backgroundColor,
      "data-active-color": _vm.activeColor
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text logo-mini",
    attrs: {
      "href": "/"
    }
  }, [_c('div', {
    staticClass: "logo-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "simple-text logo-normal",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")])]), _vm._v(" "), _c('div', {
    ref: "sidebarScrollArea",
    staticClass: "sidebar-wrapper"
  }, [_vm._t("default"), _vm._v(" "), _c('ul', {
    class: _vm.navClasses
  }, _vm._l((_vm.sidebarLinks), function(link, index) {
    return _c('li', {
      class: {
        active: _vm.isMenuActive(link) || link.active
      }
    }, [(link.children) ? _c('a', {
      attrs: {
        "data-toggle": "collapse",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.collapseMenu(index)
        }
      }
    }, [_c('i', {
      class: link.icon
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(link.name) + "\n            "), _c('b', {
      staticClass: "caret"
    })])]) : _vm._e(), _vm._v(" "), (link.children) ? _c('div', {
      attrs: {
        "aria-expanded": "true"
      }
    }, [_c('el-collapse-transition', [_c('ul', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!link.collapsed),
        expression: "!link.collapsed"
      }],
      staticClass: "nav"
    }, _vm._l((link.children), function(subLink, subLinkIndex) {
      return _c(_vm.elementType(subLink), {
        key: subLink.path,
        ref: subLink.name,
        refInFor: true,
        tag: "component",
        class: {
          active: subLink.active
        },
        attrs: {
          "to": subLink.path,
          "tag": "li"
        }
      }, [_c('a', {
        attrs: {
          "href": _vm.elementType(subLink) === 'li' ? subLink.path : '#',
          "target": subLink.target
        }
      }, [_c('span', {
        staticClass: "sidebar-mini"
      }, [_vm._v("\n                       \n                    ")]), _vm._v(" "), _c('span', {
        staticClass: "sidebar-normal"
      }, [(subLink.label) ? _c('span', {
        staticClass: "pull-right label label-success"
      }, [_vm._v(_vm._s(subLink.label))]) : _vm._e(), _vm._v("\n                    " + _vm._s(subLink.name) + "\n                  ")])])])
    }))])], 1) : _c(_vm.elementType(link, false), {
      tag: "component",
      class: {
        active: link.active
      },
      attrs: {
        "to": link.path,
        "target": link.target,
        "href": link.path
      }
    }, [_c('i', {
      class: link.icon
    }), _vm._v(" "), _c('p', [(link.label) ? _c('span', {
      staticClass: "pull-right label label-success"
    }, [_vm._v(_vm._s(link.label))]) : _vm._e(), _vm._v("\n            " + _vm._s(link.name) + "\n          ")])])], 1)
  }))], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16f78452!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/SidebarPlugin/SideBar.vue
// module id = 504
// module chunks = 55